import { render, staticRenderFns } from "./FpuiButton.vue?vue&type=template&id=4e0e1471&lang=pug&"
import script from "./FpuiButton.vue?vue&type=script&lang=js&"
export * from "./FpuiButton.vue?vue&type=script&lang=js&"
import style0 from "./FpuiButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports